import Route from '@ember/routing/route';
import { service } from '@ember/service';
import { variation } from 'ember-launch-darkly';

export default class CloudOrgsDetailProjectsDetailHvnsDetailDnsForwardingRulesRoute extends Route {
  @service router;

  async beforeModel() {
    if (!variation('hcpv-byodns')) {
      this._router.transitionTo(
        'cloud.orgs.detail.projects.detail.hvns.detail.index'
      );
    }
  }

  async model() {
    const { organization } = this.modelFor('cloud.orgs.detail');
    const { project } = this.modelFor('cloud.orgs.detail.projects.detail');
    const {
      dnsForwardings,
      dnsForwardingRules,
      dnsForwardingRulesFlatMap,
      network,
    } = this.modelFor('cloud.orgs.detail.projects.detail.hvns.detail');

    return {
      dnsForwardings,
      dnsForwardingRules,
      dnsForwardingRulesFlatMap,
      network,
      organization,
      project,
    };
  }
}
